const { Chart } = require('chart.js/auto');

function isInSubmissionReportPage() {
  return $("#submissionReportPage").length > 0;
}

window.addEventListener("load", function() {


  if (isInSubmissionReportPage()) {
    const ctx = document.getElementById('submissionReportOverviewChart');

    var options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }

      },
      scales: {
        y: {
          ticks :{
            stepSize: 10,
            beginAtZero: true,
            font: {
              size: 17
            }
          },
          title: {
            display: true,
            text: 'Returns',
            font : {
              size: 17
            }
          },
          beginAtZero: true
        },
        x:{
          ticks: {
            font: {
              size: 17
            }
          }
        }
      }
    };

    var notStarted = ctx.getAttribute("data-not-started");
    var draft = ctx.getAttribute("data-draft");
    var awaitingCertification = ctx.getAttribute("data-awaiting-certification");
    var submitted = ctx.getAttribute("data-submitted");
    var certified = ctx.getAttribute("data-certified");

    var isCertifiable = ctx.getAttribute("data-is-certifiable");

    if(isCertifiable == "true") {
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Not started', 'Draft', 'Awaiting certification', 'Certified'],

          datasets: [{
            data: [notStarted, draft, awaitingCertification, certified],
            backgroundColor: ["#1d70b8", "#ffdd00", "#f47738", "#00703c"],
            borderWidth: 0
          }]
        },
        options: options
      });
    }
    else {
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Not started', 'Draft', 'Submitted'],

          datasets: [{
            data: [notStarted, draft, submitted],
            backgroundColor: ["#1d70b8", "#ffdd00", "#00703c"],
            borderWidth: 0
          }]
        },
        options: options
      });
    }

  }
})
